var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"social-icon",class:_vm.socialClass},[_c('i',{staticClass:"fab",class:_vm.socialIcon})])}
var staticRenderFns = []

export { render, staticRenderFns }